import { post } from '@api/apiFetcher'
import { addGuest, readGuest, removeGuest, subscribeGuest } from './guestWatch'

// Stan obserwowanych ogłoszeń na stronie: jedno zapytanie po identyfikatory wszystkich kart.
const IDS_PATH = '/api/user/watched/ids'
const BATCH = 120

const state = new Map()
const queue = new Set()
// identyfikatory w zapytaniu zbiorczym, na które nie ma jeszcze odpowiedzi
const loading = new Set()
const listeners = new Set()
let token = null
let version = 0
let timer = null
const inFlight = new Map()
// ogłoszenia zapisane na tej stronie: ich stan pochodzi z odpowiedzi zapisu, nie z zapytania zbiorczego
const written = new Set()

const emit = () => { version++; listeners.forEach(fn => fn()) }

export const subscribe = fn => { listeners.add(fn); return () => listeners.delete(fn) }
export const getVersion = () => version
// gość: stan z listy w przeglądarce, wczytanej dopiero po zamontowaniu (loadGuest) — bez rozjazdu z HTML z serwera
let guest = null
export const isWatched = id => token ? state.get(String(id)) === true : Boolean(guest?.has(String(id)))

export function loadGuest () {
    if (guest) return
    const sync = () => { guest = new Set(readGuest().map(x => x.id)); emit() }
    sync()
    subscribeGuest(sync)
}

export function setToken (next) {
    const value = next || null
    if (value === token) return
    token = value
    state.clear()
    written.clear()
    loading.clear()
    emit()
}

export function register (id) {
    const key = String(id)
    if (!token || state.has(key) || queue.has(key) || loading.has(key)) return
    queue.add(key)
    if (!timer) timer = setTimeout(flush, 0)
}

async function flush () {
    timer = null
    const auth = token
    const ids = [...queue]
    queue.clear()
    ids.forEach(id => loading.add(id))
    for (let i = 0; i < ids.length; i += BATCH) {
        const part = ids.slice(i, i + BATCH)
        try {
            const res = await post({ path: IDS_PATH, data: { ids: part }, auth })
            if (auth !== token) return
            const on = new Set(res?.ids || [])
            part.forEach(id => { if (!written.has(id)) state.set(id, on.has(id)) })
        } catch (err) {
            console.log(err)
        }
    }
    ids.forEach(id => loading.delete(id))
    emit()
}

// Ponowne pobranie stanu wszystkich znanych serc (np. po dołączeniu listy gościa do konta).
export function refreshWatched () {
    const keys = [...state.keys()].filter(key => !written.has(key))
    keys.forEach(key => state.delete(key))
    keys.forEach(register)
    emit()
}

export function setWatched (id, on) {
    state.set(String(id), Boolean(on))
    emit()
}

// Ustawia stan na serwerze (zapisy jednego ogłoszenia po kolei); przy błędzie przywraca poprzedni i zwraca null,
// przy limicie obserwowanych — 'limit'. Gość: zapis w przeglądarce.
export function saveWatched ({ id, type = 'car_ad', on }) {
    const key = String(id)
    if (!token) {
        loadGuest()
        if (!on) { removeGuest(key); return Promise.resolve(false) }
        const res = addGuest({ id: key, type })
        return Promise.resolve(res === 'limit' ? 'limit' : true)
    }
    const prev = isWatched(key)
    written.add(key)
    setWatched(key, on)
    const run = async () => {
        try {
            const res = await post({ path: `/api/offers/${type}/${key}/watch`, data: { on }, auth: token })
            if (res?.code === 'limit') { setWatched(key, prev); return 'limit' }
            if (typeof res?.on !== 'boolean') throw new Error('watch')
            if (isWatched(key) === on) setWatched(key, res.on)
            return res.on
        } catch (err) {
            console.log(err)
            setWatched(key, prev)
            return null
        }
    }
    const next = (inFlight.get(key) || Promise.resolve()).then(run)
    inFlight.set(key, next)
    next.finally(() => { if (inFlight.get(key) === next) inFlight.delete(key) })
    return next
}

export const hasToken = () => Boolean(token)
export const currentToken = () => token
